import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

// TODO: In future allow this not to be hard coded.
var GameTag;
(function (GameTag) {
    GameTag["HOT"] = "hot";
    GameTag["NEW"] = "new";
    GameTag["GAME_OF_THE_MONTH"] = "gotm";
    GameTag["GAME_OF_THE_YEAR"] = "goty";
    GameTag["RECOMMENDED"] = "recommended";
    GameTag["EDITORS_CHOICE"] = "editors-choice";
    GameTag["BET"] = "bet";
})(GameTag || (GameTag = {}));
/**
 * Component renders a small tag defined in CMS as a game configuration on a
 * particular game in the games list.
 */
var TagComponent = /** @class */ (function (_super) {
    __extends(TagComponent, _super);
    function TagComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], TagComponent.prototype, "variant", void 0);
    TagComponent = __decorate([
        Component({
            name: 'ui-tag',
        })
    ], TagComponent);
    return TagComponent;
}(Mixins(MagicConfigMixin)));

export default TagComponent;
export { GameTag };
